// extracted by mini-css-extract-plugin
module.exports = {"content":"disclaime_content__KV0f_","button":"disclaime_button__M0in_"};